import {
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  Input,
  OnInit,
} from '@angular/core';
import { IconConfig } from '@rxap/utilities';
import { IconDirective } from '@rxap/material-directives/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RowDataWithNode } from 'eurogard-data-source/table/tree';

@Component({
  selector: 'eurogard-tree-control-cell, td[eurogard-tree-control-cell]',
  templateUrl: './tree-control-cell.component.html',
  styleUrls: [ './tree-control-cell.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    IconDirective,
  ],
})
export class TreeControlCellComponent implements OnInit, DoCheck {

  public offset!: string;
  public icon!: IconConfig;

  public expandIcon!: string;

  @Input('eurogard-tree-control-cell')
  public element: RowDataWithNode<any>;

  public ngOnInit() {
    this.offset = (this.element.__node.depth * 24) + 'px';
    this.updateIcon();
  }

  public ngDoCheck() {
    this.updateIcon();
  }

  public toggleExpand() {
    return this.element.__node.toggleExpand();
  }

  private updateIcon(): void {
    this.icon = this.element.icon;
    if (this.element.__node.hasChildren) {
      if (this.element.__node.expanded) {
        this.expandIcon = 'expand_more';
      } else {
        this.expandIcon = 'chevron_right';
      }
    } else {
      this.icon ??= { icon: 'subdirectory_arrow_right' };
    }
  }

}
